<template>
  <Wrapper>
    <OverlayLayout
      :width="516"
      :active="['add_section', 'add_grid', 'add_widget'].includes(mode)"
      :title="mode"
      closebtn
      :close="() => $store.dispatch('design/setMode', {})"
    >
      <template v-slot:body>
        <component :is="getDynamicContent(mode)" />
      </template>
    </OverlayLayout>
    <ModalConfirmUpgrade 
      :modalID="'modal-confirm-upgrade-insert'"
    />
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper } from "./OverlayInsert.styled";
import ModalConfirmUpgrade from "@components_system/Design/Modal/ModalConfirmUpgrade/ModalConfirmUpgrade.vue";

const Content = {
  Default: () => import(/* webpackChunkName: "SidebarDefault" */ "../Overlay/Default/Default"),
  add_section: () => import(/* webpackChunkName: "add_section" */ "./Section/Section"),
  add_grid: () => import(/* webpackChunkName: "add_grid" */ "./Grid/Grid"),
  add_widget: () => import(/* webpackChunkName: "add_widget" */ "./Widget/Widget"),
};

const componentsKey = Object.keys(Content);

export default {
  components: {
    Wrapper,
    ModalConfirmUpgrade,
    // Title,
    // CollapseContainer,
    // CollapseHeader,
    // CollapseBody,
    // CollapseSection,
    ...Content,
  },

  data() {
    return {
      // visibleDesign: false,
      visibleLayout: false,
      visibleContent: true,
      visibleTitle: false,
    };
  },
  watch: {
    elActiveID(nextVal) {
      if (nextVal[0]) {
        this.visibleContent = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      elActiveID: "design/component/elActiveID",
      activeSection: "design/component/activeSection",
      mode: "design/mode",
    }),

    activeSidebar() {
      return this.elActiveID.length > 0;
    },
  },
  methods: {
    elActive({ elementID }) {
      this.$store.dispatch("design/component/elActive", { elementID });
      if (elementID) this.scrollToId(elementID);
    },
    getDynamicContent(key) {
      if (componentsKey.indexOf(key) > -1) {
        return key;
      } else {
        return "Default";
      }
    },
  },
};
</script>